import React from 'react';
import Table from '../../../component/Table/Table';

function Order() {
  const columns = ['Customer', 'Order id', 'Item', 'Amount', 'Date', 'Status'];
  return (
    <div>
      <h2 className='text-greySecondary mb-8 ml-12 font-[500] text-3xl'>
        Order History
      </h2>
      <div>
        <Table tableHead={columns} tableData={null} />
      </div>
    </div>
  );
}

export default Order;
